/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationCreateStatus } from './ApplicationCreateStatus'
import {
  ApplicationCreateStatusFromJSON,
  ApplicationCreateStatusFromJSONTyped,
  ApplicationCreateStatusToJSON,
} from './ApplicationCreateStatus'

/**
 *
 * @export
 * @interface GetApplicationStatus200ResponseData
 */
export interface GetApplicationStatus200ResponseData {
  /**
   * Статус последней записи истории проверок (AGREE_TO_RISKY — предупреждение второго круга без услуг)
   * @type {ApplicationCreateStatus}
   * @memberof GetApplicationStatus200ResponseData
   */
  status: ApplicationCreateStatus
  /**
   * По заявке есть оплаченный сервисный продукт
   * @type {boolean}
   * @memberof GetApplicationStatus200ResponseData
   */
  serviceProductPaid: boolean
  /**
   * Ссылка на итоговый документ полной проверки; null, если документа нет
   * @type {string}
   * @memberof GetApplicationStatus200ResponseData
   */
  resultDocumentLink: string | null
  /**
   * Отформатированный номер счёта-договора
   * @type {string}
   * @memberof GetApplicationStatus200ResponseData
   */
  invoiceDocumentNumber: string | null
}

/**
 * Check if a given object implements the GetApplicationStatus200ResponseData interface.
 */
export function instanceOfGetApplicationStatus200ResponseData(
  value: object
): value is GetApplicationStatus200ResponseData {
  if (!('status' in value) || value['status'] === undefined) return false
  if (
    !('serviceProductPaid' in value) ||
    value['serviceProductPaid'] === undefined
  )
    return false
  if (
    !('resultDocumentLink' in value) ||
    value['resultDocumentLink'] === undefined
  )
    return false
  if (
    !('invoiceDocumentNumber' in value) ||
    value['invoiceDocumentNumber'] === undefined
  )
    return false
  return true
}

export function GetApplicationStatus200ResponseDataFromJSON(
  json: any
): GetApplicationStatus200ResponseData {
  return GetApplicationStatus200ResponseDataFromJSONTyped(json, false)
}

export function GetApplicationStatus200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetApplicationStatus200ResponseData {
  if (json == null) {
    return json
  }
  return {
    status: ApplicationCreateStatusFromJSON(json['status']),
    serviceProductPaid: json['serviceProductPaid'],
    resultDocumentLink: json['resultDocumentLink'],
    invoiceDocumentNumber: json['invoiceDocumentNumber'],
  }
}

export function GetApplicationStatus200ResponseDataToJSON(
  value?: GetApplicationStatus200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: ApplicationCreateStatusToJSON(value['status']),
    serviceProductPaid: value['serviceProductPaid'],
    resultDocumentLink: value['resultDocumentLink'],
    invoiceDocumentNumber: value['invoiceDocumentNumber'],
  }
}
